const formatPort = (p) => {
	if (p.code) return `${p.name} (${p.code}) (${p.country_code})`
	return `${p.name} (${p.country_code})`;
};

const reassignPorts = (report) => {
	const nextPortDict = report.operational.next_port_dict;
	const portDict = report.operational.port;
	if (nextPortDict) {
		report.operational.next_port = formatPort(nextPortDict);
		report.operational.destination_port = formatPort(nextPortDict);
	}
	if (portDict) {
		report.operational.port_name = formatPort(portDict);
	}
}

export {
	formatPort,
	reassignPorts
}